var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, " error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2698)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0786,
    r: 12,
    fill: "#E73458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84669 12.6078C9.72836 12.4842 9.65653 12.4059 9.58177 12.3306C8.51385 11.2629 7.44181 10.1987 6.37861 9.12516C5.80579 8.54718 5.89704 7.66372 6.55699 7.2523C7.02736 6.95918 7.62667 7.04041 8.05996 7.47066C9.12434 8.52834 10.184 9.59073 11.2449 10.6525C11.3208 10.7285 11.3862 10.8144 11.4768 10.9192C11.5804 10.8203 11.6576 10.7496 11.7311 10.6761C12.7996 9.60839 13.8652 8.53776 14.9372 7.4736C15.5142 6.90092 16.3643 6.96095 16.797 7.59309C17.1308 8.08102 17.0519 8.6955 16.5845 9.16519C15.5324 10.2217 14.4769 11.2747 13.4213 12.327C13.346 12.4024 13.2565 12.4636 13.1582 12.5442C13.2659 12.6596 13.3354 12.7391 13.4096 12.8132C14.4775 13.8815 15.5495 14.9456 16.6121 16.0192C17.2055 16.619 17.099 17.5378 16.4049 17.9256C15.9216 18.1958 15.3623 18.1052 14.929 17.6743C13.8658 16.6155 12.8061 15.5531 11.7441 14.4924C11.6693 14.4177 11.591 14.3471 11.5015 14.2623C11.4127 14.3465 11.3338 14.4171 11.259 14.4919C10.1899 15.5589 9.12434 16.6296 8.05172 17.6937C7.62078 18.1216 7.01794 18.1952 6.54757 17.8962C5.89057 17.4783 5.8105 16.6037 6.38744 16.0216C7.44417 14.9562 8.50796 13.898 9.57058 12.8379C9.64653 12.762 9.73601 12.6996 9.84669 12.6078Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.804e495f.svg";
export { ForwardRef as ReactComponent };